import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { Table } from "primeng/table";
import { LazyLoadEvent } from "primeng/api";
import { environment } from "src/environments/environment";
import { saveAs } from "file-saver/src/FileSaver";
import * as moment from "moment";
import { SubscribeService } from "src/app/frontend/service/subscribeService.service"
import { CountryService } from "../country/service/country.service";
import { StateService } from "../state/service/state.service";
import { CityService } from "../city/service/city.service";
import { CategoryService } from "src/app/services/category.service";
import { ReportService } from "src/app/services/report.service";
import * as XLSX from 'xlsx';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-find-a-partner-revenue',
  templateUrl: './find-a-partner-revenue.component.html',
  styleUrls: ['./find-a-partner-revenue.component.scss'],
  providers: []
})

export class FindAPartnerRevenueComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  errorMessage = "";
  searchBy: any[];
  totalRecords: 0;
  faprlist: any;
  loading: boolean;
  paginationOption;
  lastTableLazyLoadEvent: LazyLoadEvent;
  startDate: Date;
  endDate: Date;
  downloadFlg: boolean;
  downloadfaprlist: any;
  searchby;
  public hide: boolean = true;
  @ViewChild("dt", { static: false }) public dt: Table;
  sportList: any;
  countrylist: any[];
  stateList: any[];
  cityList: any[];
  countryCode: string;
  country: any;
  state: any;
  cityName: any;
  sportName: any;

  constructor(private subscribeservice: SubscribeService, private countryService: CountryService, private stateService: StateService, private cityService: CityService, private categoryService: CategoryService, private reportService: ReportService) {}

  ngOnInit() {
    this.paginationOption = environment.pagination;
    this.searchBy = [
      { label: "Date of Booking", value: "created_at" }
    ];
    this.downloadFlg = false;
    this.getCountries();
    this.getSportList();
  }

  getSportList() {
    const query = `?filterByDisable=false&getSubcategory=true&pageSize=10&pageNumber=1&filterByParentCategory=Sport`;
    this.categoryService.getCategoryWithoutAuthList(query).pipe(takeUntil(this.destroy$)).subscribe((data:any) => {
      this.sportList = data?.data?.items;
    }, err => {
      this.errorMessage = err.error.message;
    })
  }

  getCountries() {
    this.countrylist = [];
    let query = "filterByDisable=false&filterByStatus=true";
    this.countryService.getcountryList(query).pipe(takeUntil(this.destroy$)).subscribe(data => {
        if (data.data.items.length > 0) {
          data.data.items.forEach(element => {
            let countryObj = {
              name: element.name,
              iso2: element.iso2,
            }
            this.countrylist.push(countryObj);
          });
        }
      },
      err => {
        this.errorMessage = err.error.message;
      }
    );
  }

  getStates(event) {
    let countryCode = event.value.iso2;
    this.stateList = [];
    this.cityList = [];
    let query = "filterByDisable=false&orderBy=name&sortBy=1&filterByCountryCode=" + countryCode;
    this.stateService.getstateList(query).pipe(takeUntil(this.destroy$)).subscribe((res) => {
      if (res.data.items.length > 0) {
        res.data.items.forEach(element => {
          let stateObj = {
            name: element.name,
            id: element.id,
          }
          this.stateList.push(stateObj);
        });
      }
    })
    this.loadFAPRReports(this.lastTableLazyLoadEvent);
  }

  async getCities(event) {
    const stateCode = event.value.id;
    this.cityList = [];
    let query = "?filterByStatus=true&filterByDisable=false&orderBy=name&sortBy=1&filterByStateId=" + stateCode;
    this.cityService.getcityList(query).pipe(takeUntil(this.destroy$)).subscribe((res) => {
      if (res.data.items.length > 0) {
        res.data.items.forEach(element => {
          let cityObj = {
            name: element.name,
            code: element.name,
          }
          this.cityList.push(cityObj);
        });
      }
    })
    this.loadFAPRReports(this.lastTableLazyLoadEvent);
  }

  onSportChange(event) {
    this.sportName = event.value;
    const resetEvent = Object.assign({}, this.lastTableLazyLoadEvent, { first: 0 });
    if (this.dt) {
      this.dt.first = 0;
    }
    this.loadFAPRReports(resetEvent);
  }

  clear() {
    this.startDate = null;
    this.endDate = null;
    this.searchby = "";
    this.stateList = [];
    this.cityList = [];
    this.country = null;
    this.state = null;
    this.cityName = null;
    this.sportName = null;
    const resetEvent = Object.assign({}, this.lastTableLazyLoadEvent, { first: 0, filters: {} });
    if (this.dt) {
      this.dt.filters = {};
      this.dt.first = 0;
    }
    this.loadFAPRReports(resetEvent);
  }

  loadFAPRReports(event: LazyLoadEvent) {
    event = event || {} as LazyLoadEvent;
    const rows = Number(event.rows) > 0 ? Number(event.rows) : 10;
    const first = Number(event.first) >= 0 ? Number(event.first) : 0;
    const pagenumber = Math.floor(first / rows) + 1;
    const eventFilters = event.filters || {};
    this.lastTableLazyLoadEvent = Object.assign({}, event, { first, rows, filters: eventFilters });
    var query = "?filterByDisable=false";
    var params = "";
    this.subscribeservice._pendingReq.pipe(take(1), takeUntil(this.destroy$)).subscribe((res) => {
      if (res && eventFilters["status"] == undefined) {
        params += res
      }
    });
    if (
      this.searchby != undefined &&
      this.startDate != undefined &&
      this.endDate != undefined
    ) {
      params += "&filterByDate=" + this.searchby.value;
      params += "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
      params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
    }
    if (this.country) {
      params += "&filterByCountries=" + this.country.name;
    }
    if (this.state) {
      params += "&filterByState=" + this.state.name;
    }
    if (this.cityName) {
      params += "&filterByCity=" + this.cityName;
    }
    if (this.sportName) {
      params += "&filterBySportwise=" + this.sportName;
    }
    const getFilterValue = (field) => {
      if (eventFilters[field] != undefined && eventFilters[field].value !== undefined && eventFilters[field].value !== null && eventFilters[field].value !== "") {
        return eventFilters[field].value;
      }
      return null;
    };
    const columnFilters = [
      { field: "mobileNumber", parameter: "filterByFapMobileNumber" },
      { field: "username", parameter: "filterByFapUsername" },
      { field: "userCity", parameter: "filterByFapUserCity" },
      { field: "partnerName", parameter: "filterByFapPartnerName" },
      { field: "bookingId", parameter: "filterByFapBookingId" },
      { field: "playerCoachPaidHits", parameter: "filterByFapPlayerCoachPaidHits" },
      { field: "bookingCity", parameter: "filterByFapBookingCity" },
      { field: "bookingState", parameter: "filterByFapBookingState" },
      { field: "bookingCountry", parameter: "filterByFapBookingCountry" },
      { field: "dateOfBooking", parameter: "filterByFapDateOfBooking" },
      { field: "sessionStartTime", parameter: "filterByFapSessionStartTime" },
      { field: "sessionEndTime", parameter: "filterByFapSessionEndTime" },
      { field: "costPerHour", parameter: "filterByFapCostPerHour" },
      { field: "totalCost", parameter: "filterByFapTotalCost" },
      { field: "couponApplied", parameter: "filterByFapCouponApplied" },
      { field: "couponDiscountAmountPartner", parameter: "filterByFapCouponDiscountPartner" },
      { field: "couponDiscountAmountTPL", parameter: "filterByFapCouponDiscountTPL" },
      { field: "tplRevenue", parameter: "filterByFapTplRevenue" },
      { field: "gstAmount", parameter: "filterByFapGstAmount" },
      { field: "tplCommissionPercent", parameter: "filterByFapCommissionPercent" },
      { field: "tplCommissionAmount", parameter: "filterByFapCommissionAmount" },
      { field: "userPayout", parameter: "filterByFapUserPayout" },
      { field: "tplShare", parameter: "filterByFapTplShare" },
    ];

    columnFilters.forEach(columnFilter => {
      const value = getFilterValue(columnFilter.field);
      if (value !== null) {
        params += "&" + columnFilter.parameter + "=" + encodeURIComponent(String(value));
      }
    });
    // at the time of download hide pagination option
    if (this.downloadFlg == false) {
      if (params != undefined && params != "") {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
      } else {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
      }
    } else {
      if (params != undefined && params != "") {
        query += params;
      }
    }
    if (event.sortField != undefined && event.sortOrder != undefined) {
      var orderBy = "";
      if (event.sortOrder == 1) {
        orderBy = "ASC";
      } else {
        orderBy = "DESC";
      }
      query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    }
    this.reportService.getFAPRReport(query).pipe(takeUntil(this.destroy$)).subscribe(
      (data:any) => {
        if (this.downloadFlg === false) {
          this.loading = false;
          this.faprlist = data;
          this.totalRecords = data.totalCount;
        } else {
          this.exportFAPRReportListData(data);
          this.downloadFlg = false;
        }
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }

  setDownloadFlag() {
    this.downloadFlg = false;
  }

  exportExcel() {
    this.downloadFlg = true;
    this.loadFAPRReports(this.lastTableLazyLoadEvent);
  }

  async exportFAPRReportListData(faprReportList) {
    this.downloadfaprlist = JSON.parse(JSON.stringify(faprReportList));
    var propertiesRemove = ['message', 'pageNumber', 'pageSize', 'status', 'totalCount', 'totalPages'];
    propertiesRemove.forEach((prop) => {
      delete this.downloadfaprlist[prop];
    }); 
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet([]); 
    // Set column widths
    const colWidths = [
      { wch: 15 },{ wch: 20 }, { wch: 15 }, { wch: 20 }, { wch: 25 },
      { wch: 15 }, { wch: 12 }, { wch: 12 }, { wch: 15 },{ wch: 15 },{ wch: 35 }
    ];
    worksheet['!cols'] = colWidths; 
    // Add parent section with visual separation
    const parentSection = [
        [],
        ["Total Number of Users","Total Partners Booked", "Total Number of Booking Cities","Total Cost","Total Coupon Amount (Partner)","Total Coupon Amount (TPL)","Total TPL Revenue","Total TPL Commission Amount","Total User Payout","Total TPL Share"],
        [ this.totalRecords, this.downloadfaprlist.summary.totalPartnersBooked, this.downloadfaprlist.summary.totalBookingCities, this.downloadfaprlist.summary.totalCost, this.downloadfaprlist.summary.totalCouponAmountPartner, this.downloadfaprlist.summary.totalCouponAmountTPL, this.downloadfaprlist.summary.totalTPLRevenue, this.downloadfaprlist.summary.totalTPLCommissionAmount, this.downloadfaprlist.summary.totalUserPayout, this.downloadfaprlist.summary.totalTPLShare],
        [], 
        ['Mobile Number', 'Username', 'User City', 'Partner Name', 'BookingID', 'Player/Coach/Paid Hits', 'Booking City', 'Booking State', 'Booking Country', 'Date of Booking', 'Session Start Time', 'Session End Time', 'Cost Per Hour', 'Total Cost', 'Coupon Applied', 'Coupon Discount Amount (Partner)', 'Coupon Discount Amount (TPL)', 'TPL Revenue', 'GST Amount', 'TPL Commission % ', 'TPL Commission Amount', 'User Payout', 'TPL Share']
      ];       
      XLSX.utils.sheet_add_aoa(worksheet, parentSection, { origin: -1 });       
      this.downloadfaprlist['data'].forEach((parent: any) => {
        if (parent.dateOfBooking) {
          parent.dateOfBooking = moment(parent.dateOfBooking).format("DD-MM-YYYY");
        }
        let couponAppliedStr = parent.couponApplied ? 'Yes' : 'No';
        let tplCommissionPercentageStr = parent.tplCommissionPercent != null && parent.tplCommissionPercent !== undefined ? parent.tplCommissionPercent + ' %' : '';
        XLSX.utils.sheet_add_aoa(worksheet, [
          [
            parent.mobileNumber,
            parent.username,
            parent.userCity ? parent.userCity.name : '',
            parent.partnerName,
            parent.bookingId,
            parent.playerCoachPaidHits,
            parent.bookingCity,
            parent.bookingState,
            parent.bookingCountry,
            parent.dateOfBooking,
            parent.sessionStartTime,
            parent.sessionEndTime,
            parent.costPerHour,
            parent.totalCost,
            couponAppliedStr,
            parent.couponDiscountAmountPartner,
            parent.couponDiscountAmountTPL,
            parent.tplRevenue,
            parent.gstAmount,
            tplCommissionPercentageStr,
            parent.tplCommissionAmount,
            parent.userPayout,
            parent.tplShare
          ],
        ], { origin: -1 });
      }); 
    XLSX.utils.book_append_sheet(workbook, worksheet, "FIND_A_PARTNER_REPORT");
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([excelBuffer]), "Find_A_Partner_Revenue_Report.xlsx"); 
      this.downloadFlg = false;
  }
    
  addColumns() {
    this.hide = false;
  }
  
  removeColumns() {
    this.hide = true;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
